import type { ReactNode } from 'react'

/**
 * The words a search looks for, split the way the server splits them (lower case, words of three or more characters),
 * longest first so a longer word wins where two overlap.
 */
export function searchWordsOf(phrases: string[]): string[] {
  const words =
    phrases
      .join(' ')
      .toLowerCase()
      .match(/[a-z0-9$€£%.]+/g) ?? []
  return [...new Set(words.filter((word) => word.length > 2))].sort((a, b) => b.length - a.length)
}

/** The quote with each word the search looked for marked; text nodes only, never HTML. */
export function highlightedQuote(text: string, words: string[]): ReactNode[] {
  if (words.length === 0) return [text]
  const nodes: ReactNode[] = []
  let last = 0
  for (const match of text.matchAll(new RegExp(words.map(escapeRegExp).join('|'), 'gi'))) {
    const start = match.index
    nodes.push(text.slice(last, start))
    nodes.push(
      <span key={start} className="rounded-sm bg-white/10 px-0.5 text-foreground">
        {match[0]}
      </span>
    )
    last = start + match[0].length
  }
  nodes.push(text.slice(last))
  return nodes
}

export function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
